import Product from "./Product";
import Environment from "./Enviroment";
import State from "../models/State"
export default class Subscription {
  public id: string
  public createdOn: string
  public updatedOn: string
  public entityId: string
  public product: Product
  public environment: Environment
  public updateByUserId: string
  public state: State
  public assetName: string
  public entityName: string
  public roles: any[]
  public subscriptionProvider: string
}



// WEBPACK FOOTER //
// ./src/modules/subscription/models/Subscription.ts